// mixin.js
// import Vue from "vue";
import { uploadFile } from '../api/commonV2'
import Clipboard from 'clipboard'
const mixin = {
  data () {
    return {
      m_color: window.g.main_color,
      m_tel: window.g.m_tel,
      m_rate: window.g.rate,
      m_ztkrateGui: window.g.tao_rate,//淘宝、天猫rate
      beforeStr: window.g.BeforeURL,
      agreement: window.g.agreement,
      platChat: window.g.platChat,
      defaultImg: require('../assets/logo.png'),
      outUrl: window.g.goOut,
      appLogo:window.g.appLogo,
      sname: {
        1: {
          productId: 'productId', // 商品ID
          productCode: 'productCode', // 商品ID
          coverImage: 'coverImage', // 商品封面图片
          productName: 'productName', // 商品名称
          price: 'price', // 商品售价
          originalPrice: 'originalPrice', // 商品原价
          couponMoney: 'couponMoney', // 券额
          integral: 'integral', // 商品铜板
          salesVolume: 'salesVolume', // 销量
          category_id: 'category_id',
          pricepoint: 1,
          zkrate: 1,
          shopCode: 'shopId',
          after: '?x-oss-process=image/resize,m_fill,h_200,w_200',
          isdl:'isdl', // 是否是代理商品0否1是
          ishot:'ishot', // 是否砍一刀专区爆品产品 0否 1是
          isbd:'isbd',//商品专区类型判断 0普通商品 2是惠淘好货3爆品购物券兑换专区
          diff:'diff', // 差额
          // extensiondiff:'extensiondiff',  // 推广差额（不低于4元）
          region:'region',      // 区域销售补贴
          community:'community'      // 社群销售补贴
        },
        tk: {
          productId: 'item_id', // 商品ID
          coverImage: 'pict_url', // 商品封面图片
          productName: 'title', // 商品名称
          price: 'zk_final_price', // 商品售价
          originalPrice: 'reserve_price', // 商品原价
          couponMoney: 'coupon', // 券额
          integral: '', // 商品铜板
          salesVolume: 'volume', // 销量
          rate: 'commission_rate',
          point: 10000,
          category_id: 'category_id',
          pricepoint: 1,
          zkrate: window.g.tao_rate
        },
        jd: {
          // productId: 'skuId', // 商品ID
          // coverImage: 'imageInfo.imageList[0].url', // 商品封面图片
          // productName: 'skuName', // 商品名称
          // price: 'priceInfo.lowestPrice', // 商品售价
          // originalPrice: '', // 商品原价
          // couponMoney: 'couponInfo.couponList[0].discount', // 券额
          // integral: '', // 商品铜板
          // salesVolume: 'inOrderCount30Days', // 销量
          // rate: 'commissionInfo.commission',
          // point: 100,
          // category_id: 'category_id',
          // pricepoint: 1,
          // zkrate: 1,
          productId: 'goodsId', // 商品ID
          coverImage: 'goodsImage', // 商品封面图片
          productName: 'goodsName', // 商品名称
          price: 'price', // 商品售价
          originalPrice: 'oriPrice', // 商品原价
          couponMoney: 'coupon', // 券额
          integral: 'tongBan', // 商品铜板
          salesVolume: 'saleVolume', // 销量
          // rate: 'commissionInfo.commission',
          // point: 100,
          category_id: 'cateId',
          // pricepoint: 1,
          // zkrate: 1,
          after:''
        },
        ztk: {
          productId: 'tao_id', // 商品ID
          productCode: 'tao_id', // 商品ID
          coverImage: 'pict_url', // 商品封面图片
          productName: 'tao_title', // 商品名称
          price: 'quanhou_jiage', // 商品售价
          originalPrice: 'size', // 商品原价
          couponMoney: 'coupon_info_money', // 券额
          integral: 'tkfee3', // 商品铜板
          salesVolume: 'volume', // 销量
          tkrate3: '',
          point: 100,
          category_id: 'type_one_id',
          pricepoint: 1,
          zkrate: window.g.tao_rate,
          shopCode: 'seller_id',
          after: '_310x310.jpg'
        },
        pdd: {
          productSign: 'goods_sign', // 拼多多加密后的商品id
          productId: 'goods_id', // 商品ID
          productCode: 'goods_id', // 商品ID
          coverImage: 'goods_image_url', // 商品封面图片
          productName: 'goods_name', // 商品名称
          price: 'min_group_price', // 商品售价
          originalPrice: 'min_group_price', // 商品原价
          couponMoney: 'coupon_discount', // 券额
          integral: 'integral', // 商品铜板
          salesVolume: 'sales_tip', // 销量
          rate: 'promotion_rate',
          point: 1000,
          pricepoint: 0.01, // 价格比例
          category_id: 'type_one_id',
          zkrate: window.g.rate,
          shopCode: 'seller_id',
          after: ''
        },
        wph: {
          productId: 'productId', // 商品ID
          productCode: 'productId', // 商品ID
          coverImage: 'coverImage', // 商品封面图片
          productName: 'productName', // 商品名称
          price: 'price', // 商品售价
          originalPrice: 'originalPrice', // 商品原价
          couponMoney: 'couponMoney', // 券额
          salesVolume: 'salesVolume', // 销量
          integral: 'integral', // 商品铜板(后面无)
          rate: 'promotion_rate',
          point: 1000,
          pricepoint: 0.01, // 价格比例
          category_id: 'type_one_id',
          zkrate: window.g.rate,
          shopCode: 'seller_id',
          after: ''
        }
      },
      isIos: false,
      hello: 'hello Mixin',
      default_headIcon: require('../assets/image/common/headImage.png'),
      showTypes: {
        1: '1',
        2: 'ztk',
        3: 'ztk',
        4: 'ztk',
        5: 'ztk',
        6: 'ztk',
        7: 'ztk',
        8: 'jd',
        9: 'ztk',
        10: 'pdd',
        11: 'ztk',
        101: 'ztk',
        ztk: 'ztk',
        yd: '1',
        bp: '1',
        xp: '1',
        120: 'wph'
      }, // 列表展示分类,
      // lazyimg: require(),
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        // callback: this.downCallback,
        // htmlContent: '<p class="downwarp-progress"></p><p class="downwarp-tip"></p>'
      }, // 下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: { // 上拉加载的配置.
        auto: true,
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        // 以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, // 当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 // 每页数据条数,默认10
        },
        // htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;
        // 避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        // 这就是为什么无更多数据有时候不显示的原因
        toTop: {
          // 回到顶部按钮
          // warpClass: 'mescroll-totop-my',
          // src: null, // 图片路径,默认null,支持网络图
          // offset: 1000 // 列表滚动1000px才显示回到顶部按钮
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          warpId: 'listId', // 父布局的id (1.3.5版本支持传入dom元素)
          icon: require('../assets/image/common/empty.png'), // 图标,默认null,支持网络图
          tip: '暂无相关数据~' // 提示
        }
      }
    }
  },
  created () {
    this.isIos = !this.isAndroid()
    // console.log('在mixin中vue的data、生命周期、方法等都可以使用');
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$nextTick(
        function () {
          vm.$refs.mescroll && vm.$refs.mescroll.beforeRouteEnter() // 进入路由时,滚动到原来的列表位置,恢复回到顶部按钮和isBounce的配置
        }
      )
    })
  },
  beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
    // 找到当前mescroll的ref,调用子组件mescroll-vue的beforeRouteLeave方法
    this.$refs.mescroll && this.$refs.mescroll.beforeRouteLeave() // 退出路由时,记录列表滚动的位置,隐藏回到顶部按钮和isBounce的配置
    this.mescroll ? this.mescroll.hideTopBtn(0.5) : ''
    next()
  },
  filters: {
    // 手机号脱敏
    hidetel (val) {
      if (val) {
        let str1 = val.substr(0, 3)
        let str2 = val.substr(7, 4)
        return str1 + '****' + str2
      }
    },
    // 手机号脱敏
    hideName (val) {
      if (val) {
        let str1 = val.substr(0, 1)
        let str2 = val.substr(-1, 1)
        return str1 + '****' + str2
      }
    },
    // 规格格式化
    getspecification (val) {
      if (val) {
        console.log(val)
        let arr = JSON.parse(val)
        let str = ''
        for (let i = 0; i < arr.length; i++) {
          str = str + arr[i].value + ' '
        }
        return str
      }
    },
    // 代码格式化
    getHtml (val) {
      let a = '' + val
      let str = a.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&apos;/g, "'")
      console.log(str)
      return str
    },
    //  字符串切割
    overWord (val, len) {
      if (val) {
        if (val.length > len) {
          return val.substr(0, len) + '...'
        }
      }
      return val
    }
  },
  methods: {
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit (mescroll) {
      this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上传图片
    upFile (file, detail) {
      let data = new FormData()
      data.append('file', file.file)
      uploadFile(data).then(res => {
        if (res.result === '0') {
          file.url = res.url
          file.path = res.url
          // this[detail.name][detail.index].url = window.g.BeforeURL + res.url
          // this[detail.name][detail.index].path = res.url
        }
      })
    },
    getString (val) {
      let otherImage = []
      if (val) {
        for (let i = 0; i < val.length; i++) {
          otherImage.push(val[i].path)
        }
        return JSON.stringify(otherImage)
        // return otherImage.join('|')
      }
    },
    // 上传照片，数组转换成字符串，并以|竖线隔开,调用实例
    getStringgui (val) {
      let otherImage = []
      if (val) {
        for (let i = 0; i < val.length; i++) {
          otherImage.push(val[i].path)
        }
        // return JSON.stringify(otherImage)
        return otherImage.join('|')
      }
    },
    // 字符串转数字
    toNum (val) {
      if (parseFloat(val)) {
        return parseFloat(val)
      } else {
        return 0
      }
    },
    showRule (url, tit) {
      this.$router.push({path: '/common/rule', query: {url: url, title: tit}})
    },
    // 代码格式化
    getHtml (val) {
      let a = '' + val
      let str = a.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&apos;/g, "'")
      // console.log(str)
      return str
    },
    // 复制
    onCopy (mes) {
      // console.log(mes);
      // var clipboard = new Clipboard('.copy', {
      //   text: function () {
      //     return mes
      //   }
      // })
      // clipboard.on('success', e => {
      //   this.showToast('复制成功')
      // })
      try {
        const clipboard = new Clipboard('.copy', {
          text: () => mes
        });

        clipboard.on('success', e => {
          this.showToast('复制成功');
          clipboard.destroy(); // 复制成功后销毁实例
        });

        clipboard.on('error', e => {
          this.showToast('复制失败，请手动选择文本复制');
          clipboard.destroy(); // 复制失败后销毁实例
        });
      } catch (error) {
        console.error('复制功能异常:', error);
        this.showToast('复制功能初始化失败');
      }
    },
    // 判断是否是微信
    isWx () {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    isZfb () {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/alipayclient/i) == 'alipayclient') {
        return true
      } else {
        return false
      }
    },
    // 判断是否安卓
    isAndroid () {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      if (isAndroid) {
        return true
      } else {
        return false
      }
    },
    //sys.browser得到浏览器的类型，sys.ver得到浏览器的版本
    getBrowserInfo(){
      var Sys = {};
      if( this.isIos && this.isWx() ){
        Sys.browser = ''
        Sys.ver = ''
      }else {
        var ua = navigator.userAgent.toLowerCase();
        var re =/(msie|firefox|chrome|opera|version).*?([\d.]+)/;
        var m = ua.match(re);
        Sys.browser = m[1].replace(/version/, "'safari");
        Sys.ver = (m[2]);
      }
      return Sys;
    },
    /**
     * 来源
     * @param val
     * @returns {string}
     */
    getSource(val) {
      switch (val) {
        case 'YD':
          return '我惠云店'
          break;
        case 'ALI':
          return '淘宝'
          break;
        case 'JD':
          return '京东'
          break;
        case 'PDD':
          return '拼多多'
          break;
        case 'CX_JP':
          return '机票'
          break;
        case 'CX_HCP':
          return '火车票'
          break;
        case 'CX_JD':
          return '酒店'
          break;
        case 'YD_YHQ':
          return '优惠券'
          break;
      }
    },
    /**
     * 格式化时间
     * @param time
     * @returns {*}
     */
    formatTime(time){
      return time.replace(/\//g, '-')
    }
  }
}
export default mixin



// WEBPACK FOOTER //
// ./src/util/mixin.js